var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOrderScheduled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 48,
    viewBox: "0 0 215 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85352 32.1086C1.85352 32.1086 10.184 31.033 19.6552 33.6169C37.6689 38.5315 38.6966 29.5318 45.3763 25.1923C51.4874 21.2222 56.5486 23.6445 63.353 28.4997C68.3715 32.0805 75.6853 38.0915 83.2595 37.1238C90.1832 36.2392 95.0915 29.1892 104.688 27.3963C112.295 25.9753 118.476 29.8792 127.234 28.4997C139.116 26.6282 144.423 15.6107 152.915 15.6107C163.396 15.6107 170.775 6.29248 180.31 6.29248C189.788 6.29248 191.075 11.7718 201.443 15.6107C209.369 18.5456 213.183 15.6107 213.183 15.6107V47.0598H1.85352V32.1086Z",
    fill: "url(#paint0_linear_8655_9938)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85352 27.2239C1.85352 27.2239 10.184 26.1638 19.6552 28.7104C37.6689 33.5538 38.6966 24.6844 45.3763 20.4077C51.4874 16.4951 56.5486 18.8823 63.353 23.6672C68.3715 27.1963 75.6853 33.1202 83.2595 32.1665C90.1832 31.2947 95.0915 24.3468 104.688 22.5798C112.295 21.1794 118.476 25.0268 127.234 23.6672C139.116 21.8228 144.423 10.9648 152.915 10.9648C163.396 10.9648 170.775 1.75928 180.31 1.75928C189.788 1.75928 190.292 7.18149 200.66 10.9648C208.587 13.8572 213.183 10.9648 213.183 10.9648",
    stroke: "#E9AB6C",
    strokeWidth: 2.71268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8655_9938",
    x1: 40.0463,
    y1: 26.978,
    x2: 40.0463,
    y2: 47.0598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9AB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOrderScheduled);
export default __webpack_public_path__ + "static/media/home-order-scheduled.2bb9c76b8a76a178f38e39681d03f703.svg";
export { ForwardRef as ReactComponent };